import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SeriesWriteRequest } from '~/apis/ssf';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateSeriesMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.seriesCreate>[0]) => SSF.api.seriesCreate(variables),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useUpdateSeriesMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: SeriesWriteRequest }) => SSF.api.seriesUpdate(id, payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteSeriesMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.seriesDestroy>[0]) => SSF.api.seriesDestroy(variables),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
